import { ChainName } from 'src/common/static'

export enum WALLET_TYPE {
  MINTING = 'MINTING',
  TREASURY = 'TREASURY'
}
export enum ClaimStatus {
  UNCLAIMED = 'unclaimed',
  CLAIMED = 'claimed'
}

export enum MintStatus {
  INITIATED = 'initiated',
  QUEUED = 'queued',
  PROCESSED = 'processed',
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  EXPIRED = 'expired',
  DECLINED = 'declined',
  FAILED = 'failed'
}

export enum SnapshotStatus {
  ACTIVE = 'active',
  NOT_REGISTERED = 'not_registered'
}

export enum AuditAction {
  REVENUE_SHARE_CLAIMED = 'Revenue Share Claimed',
  MINT_PROCESSED = 'Mint Processed',
  COMMENT_ADDED = 'Comment Added'
}

// One daily (4:00 PM EST) balance snapshot for an eligible wallet.
export interface DailySnapshot {
  date: string
  status: SnapshotStatus
  snapshotTime: string | null
  balanceQcad: number
  effectiveRate: number
  dailyRevenueQcad: number
  cumulativeAccrualQcad: number
  forecast?: boolean
}

export interface RevSharingWallet {
  name: string
  address: string
  chain: ChainName
}

export interface EligibleWallet {
  id: string
  name: string
  address: string
  chain: ChainName
  walletType: WALLET_TYPE
  bankLabel?: string
  daysEligible: number
  periodDays: number
  prorated: boolean
  avgDailyBalanceQcad: number
  grossAccrualQcad: number
  effectiveRate: number
  isRevSharingWallet: boolean
  previouslyEligible: boolean
  snapshots: DailySnapshot[]
}

export interface EarningStatement {
  id: string
  period: string
  statementDate: string
  scheduledMintDate: string
  daysInPeriod: number
  avgDailyBalanceQcad: number
  effectiveRate: number
  grossAccrualQcad: number
  allowableExpensesQcad: number
  netRevenuePayoutQcad: number
  claimStatus: ClaimStatus
  claimedAt: string | null
  mintStatus: MintStatus | null
  mintTxHash: string | null
  mintTxDate: string | null
  mintTxChain?: ChainName
  revSharingWallet: RevSharingWallet
  pdfAvailable: boolean
  comments: string | null
  claimedBy: string | null
  updatedAt: string
}

export interface AuditLogEntry {
  id: string
  timestamp: string
  user: string
  action: AuditAction
  statementId: string
  period: string
  details: string
  txHash?: string
  txChain?: ChainName
}

export interface UnclaimedSummary {
  statementId: string
  period: string
  amountQcad: number
  revSharingWalletName: string
}

export interface PortalMetrics {
  currentPeriodLabel: string
  periodDays: number
  netRevenuePayoutMtdQcad: number
  effectiveRate: number
  avgDailyBalanceMtdQcad: number
  unclaimed: UnclaimedSummary | null
}

// The single aggregate the portal page loads.
export interface EarningPortalData {
  metrics: PortalMetrics
  eligibleWallets: EligibleWallet[]
  statements: EarningStatement[]
  auditLog: AuditLogEntry[]
}
